import { GlobalVars } from "../global/globalVars";
import UilBox from "@iconscout/react-unicons/icons/uil-box";
import UilBuilding from "@iconscout/react-unicons/icons/uil-building";
import UilCalenderSlash from "@iconscout/react-unicons/icons/uil-calendar-slash";
import UilClipboard from "@iconscout/react-unicons/icons/uil-clipboard";
import UilCheckCircle from "@iconscout/react-unicons/icons/uil-check-circle";
import UilCheck from "@iconscout/react-unicons/icons/uil-check";
import UilPlug from "@iconscout/react-unicons/icons/uil-plug";
import UilSync from "@iconscout/react-unicons/icons/uil-sync";
import UilTelegramAlt from "@iconscout/react-unicons/icons/uil-telegram-alt";
import UilWheelBarrow from "@iconscout/react-unicons/icons/uil-wheel-barrow";
import UilWrench from "@iconscout/react-unicons/icons/uil-wrench";

const size = GlobalVars.iconSize.xs;

// https://iconscout.com/unicons/explore/line

export const eventIcons = {
    Box: {
        icon: <UilBox size={size} />,
    },
    Building: {
        icon: <UilBuilding size={size} />,
    },
    Calendar: {
        icon: <UilCalenderSlash size={size} />,
    },
    Check: {
        icon: <UilCheck size={size} />,
    },
    Clipboard: {
        icon: <UilClipboard size={size} />,
    },
    CheckCircle: {
        icon: <UilCheckCircle size={size} />,
    },
    Plug: {
        icon: <UilPlug size={size} />,
    },
    Sync: {
        icon: <UilSync size={size} />,
    },
    Telegram: {
        icon: <UilTelegramAlt size={size} />,
    },
    WheelBarrow: {
        icon: <UilWheelBarrow size={size} />,
    },
    Wrench: {
        icon: <UilWrench size={size} />,
    },
};